import React from "react";
import PropTypes from "prop-types";

import PortalDropdown, { DropdownMenuItem } from "views_shared/app/javascript/components/PortalDropdown";

/**
 * HeaderKebabMenu — the profile header's overarching owner/admin control surface (the "⋯"
 * that sits beside Share Profile). Purely presentational: the caller decides whether it
 * renders at all (owner/admin viewers only — never rendered for anyone else), and supplies
 * both callbacks. Both items open the engine's existing header edit modal; "Profile
 * Visibility…" opens the same modal, where the visibility control lives.
 *
 * Delete Profile is deliberately not scaffolded here — no destroy endpoint exists yet.
 *
 * Built on the same `PortalDropdown` + `DropdownMenuItem` shell `ConversationDropdown` uses.
 *
 * @param {Object} props
 * @param {Function} props.onEditProfile - Opens the header edit modal
 * @param {Function} props.onEditVisibility - Opens the header edit modal (visibility control)
 */
function HeaderKebabMenu({ onEditProfile, onEditVisibility }) {
  return (
    <PortalDropdown toggleAriaLabel="Profile actions">
      <DropdownMenuItem icon="fa-regular fa-pen" label="Edit Profile" onClick={onEditProfile} />
      <DropdownMenuItem icon="fa-regular fa-eye" label="Profile Visibility…" onClick={onEditVisibility} />
    </PortalDropdown>
  );
}

HeaderKebabMenu.propTypes = {
  onEditProfile: PropTypes.func.isRequired,
  onEditVisibility: PropTypes.func.isRequired,
};

export default HeaderKebabMenu;
